export default {
  ALL_ALIGNERS: 'ALL_ALIGNERS',
  CURRENT_ALIGNER: 'CURRENT_ALIGNER',
  PENDING_UPDATES: 'PENDING_UPDATES',
  ISSUES_REPORTED: 'ISSUES_REPORTED',
  ALIGNER_CHECKINS: 'ALIGNER_CHECKINS',
  ALIGNER_CHANGES: 'ALIGNER_CHANGES',
} as const
